import { isEmpty } from 'lodash-es';
import { useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { IWorkspaceUser, accountManagerAutoComplete } from 'wisestep-api';
import { WsAutocompleteInput } from 'wisestep-base';

import { extractEmail, getUserNameAndEmail } from '../../../utils/StringUtils';
import WsFilterProps from '../models/WsFilterProps';

const AccountManagerUserFilter = ({
  name,
  multiple,
  placeHolder = 'Eg,Michael',
  showMandatorySymbol = false,
  isBorderStyle = false,
}: WsFilterProps) => {
  const users = useRef<IWorkspaceUser[]>([]);
  const abortControllerRef = useRef(new AbortController());

  const { setValue } = useFormContext();

  const onChange = (event) =>
    setValue(
      name,
      event?.map((email) => extractEmail(email))
    );

  const debounce = (mainFunction, delay) => {
    let timer;

    return async (text: string): Promise<string[]> => {
      if (timer) clearTimeout(timer);
      const resultPromise = new Promise<string[]>((resolve) => {
        timer = setTimeout(async () => {
          if (abortControllerRef.current) abortControllerRef.current.abort();
          const newAbortController = new AbortController();
          abortControllerRef.current = newAbortController;
          const result = await mainFunction(text, newAbortController.signal);
          resolve(result);
        }, delay);
      });
      return await resultPromise;
    };
  };

  const onUserInputKey = async (searchText: string, singal: AbortSignal) => {
    const data: string[] = [];
    if (searchText?.length > 2) {
      try {
        const response = await accountManagerAutoComplete(
          `${encodeURIComponent(
            searchText
              ?.trim()
              .split(' ')
              .map((name) => (isEmpty(name) ? '' : name + ':*'))
              .join(' & ')
          )}`,
          singal
        );
        users.current = response.data;
        return users.current?.map((user) => getUserNameAndEmail(user)) ?? [];
      } catch (error) {
        console.error('Error fetching user:', error);
      }
    }
    return data;
  };

  return (
    <WsAutocompleteInput
      name={name}
      key={name}
      options={[]}
      placeholder={placeHolder}
      getOptions={debounce(onUserInputKey, 150)}
      showMandatorySymbol={showMandatorySymbol}
      onChange={onChange}
      requireMultiValueSelection={true}
      multiple={multiple}
      freeSolo={true}
      isBorderStyle={isBorderStyle}
    />
  );
};
export default AccountManagerUserFilter;
